/* Adele Or - Site-wide enhancements v8 (Quiz + Newsletter + Tooltips + FS Bar + Trust + Schema) */
(function(){

  /* ============================================================
   *  FRAGRANCE QUIZ POPUP — slide-in bottom-right, 15 sec delay
   * ============================================================ */
  var QUIZ_DELAY = 15000;
  var QUIZ_COOLDOWN_DAYS = 7;
  var QUIZ_POPUP_ID = 'ao-quiz-popup';

  function aoQuizCanShow(){
    try {
      if (window.location.pathname.indexOf('/pages/fragrance-quiz') === 0) return false;
      var last = localStorage.getItem('ao_quiz_popup_seen');
      if (!last) return true;
      var ago = (Date.now() - parseInt(last, 10)) / (1000*60*60*24);
      return ago > QUIZ_COOLDOWN_DAYS;
    } catch(e) { return true; }
  }
  function aoQuizClose(){
    var el = document.getElementById(QUIZ_POPUP_ID);
    if (el) { el.style.opacity = '0'; el.style.transform = 'translateY(20px)'; setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); }, 400); }
    try { localStorage.setItem('ao_quiz_popup_seen', Date.now().toString()); } catch(e){}
  }
  window.aoQuizClose = aoQuizClose;
  function aoQuizShow(){
    if (!aoQuizCanShow()) return;
    if (document.getElementById(QUIZ_POPUP_ID)) return;
    if (document.getElementById('ao-newsletter-overlay')) return;
    var wrap = document.createElement('div');
    wrap.id = QUIZ_POPUP_ID;
    wrap.style.cssText = 'position:fixed;bottom:24px;right:24px;max-width:340px;width:calc(100vw - 48px);background:linear-gradient(135deg,#faf5ec 0%,#f7f1e8 100%);border:1px solid rgba(184,146,74,.35);border-radius:18px;box-shadow:0 16px 48px rgba(107,90,71,.18);padding:24px 22px;z-index:99998;font-family:"Helvetica Neue",Arial,sans-serif;opacity:0;transform:translateY(20px);transition:opacity .4s ease,transform .4s ease;box-sizing:border-box';
    wrap.innerHTML = '<button onclick="aoQuizClose()" aria-label="Close" style="position:absolute;top:10px;right:12px;background:none;border:none;color:#6b5a47;font-size:22px;cursor:pointer;line-height:1;padding:4px 8px;border-radius:6px;font-family:inherit">×</button>'+
      '<p style="text-transform:uppercase;letter-spacing:.25em;font-size:9px;color:#b8924a;margin:0 0 10px;font-weight:600">Adele Or</p>'+
      '<h4 style="font-family:\'Playfair Display\',Georgia,serif;font-size:20px;font-weight:500;color:#2b2521;margin:0 0 8px;line-height:1.25">Not sure which scent is yours?</h4>'+
      '<p style="font-size:13px;color:#6b5a47;line-height:1.55;margin:0 0 16px">Take our 60-second quiz and discover the fragrance crafted for you.</p>'+
      '<a href="/pages/fragrance-quiz" style="display:inline-block;background:#2b2521;color:#faf5ec;text-decoration:none;padding:11px 22px;border-radius:999px;font-size:11px;letter-spacing:.18em;text-transform:uppercase;font-weight:600;transition:background .2s">Find My Signature →</a>';
    document.body.appendChild(wrap);
    requestAnimationFrame(function(){ wrap.style.opacity = '1'; wrap.style.transform = 'translateY(0)'; });
  }

  /* ============================================================
   *  NEWSLETTER POPUP — centered modal, 30 sec delay, WELCOME15
   * ============================================================ */
  var NL_DELAY = 30000;
  var NL_COOLDOWN_DAYS = 14;
  var NL_OVERLAY_ID = 'ao-newsletter-overlay';

  function aoNlCanShow(){
    try {
      var skip = ['/cart','/checkout','/account','/pages/wholesale','/pages/fragrance-quiz'];
      for (var i=0;i<skip.length;i++){ if (window.location.pathname.indexOf(skip[i]) === 0) return false; }
      var seen = localStorage.getItem('ao_nl_seen');
      var subscribed = localStorage.getItem('ao_nl_subscribed');
      if (subscribed === '1') return false;
      if (!seen) return true;
      var ago = (Date.now() - parseInt(seen, 10)) / (1000*60*60*24);
      return ago > NL_COOLDOWN_DAYS;
    } catch(e) { return true; }
  }
  function aoNlClose(){
    var el = document.getElementById(NL_OVERLAY_ID);
    if (el) { el.style.opacity = '0'; setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); document.body.style.overflow=''; }, 320); }
    try { localStorage.setItem('ao_nl_seen', Date.now().toString()); } catch(e){}
  }
  window.aoNlClose = aoNlClose;

  function aoNlCopyCode(){
    var input = document.getElementById('ao-nl-code');
    if (!input) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText('WELCOME15'); }
      else { input.select(); document.execCommand('copy'); }
      var btn = document.getElementById('ao-nl-copy-btn');
      if (btn) { var t = btn.textContent; btn.textContent = 'Copied!'; setTimeout(function(){ btn.textContent = t; }, 1800); }
    } catch(e){}
  }
  window.aoNlCopyCode = aoNlCopyCode;

  function aoNlSubmit(e){
    if (e) e.preventDefault();
    var form = document.getElementById('ao-nl-form');
    if (!form) return false;
    var email = (form.querySelector('input[type="email"]') || {}).value || '';
    if (!email || email.indexOf('@') === -1) return false;
    var iframe = document.createElement('iframe');
    iframe.name = 'ao_nl_iframe'; iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var hidden = document.createElement('form');
    hidden.method = 'post';
    hidden.action = '/contact#contact_form';
    hidden.target = 'ao_nl_iframe';
    hidden.style.display = 'none';
    hidden.innerHTML = '<input name="form_type" value="customer">'+
      '<input name="utf8" value="✓">'+
      '<input name="contact[tags]" value="newsletter,welcome15">'+
      '<input name="contact[accepts_marketing]" value="true">'+
      '<input name="contact[email]" value="'+ email.replace(/"/g,'') +'">';
    document.body.appendChild(hidden);
    hidden.submit();
    try { localStorage.setItem('ao_nl_subscribed', '1'); } catch(e){}
    aoNlShowSuccess();
    return false;
  }
  window.aoNlSubmit = aoNlSubmit;

  function aoNlShowSuccess(){
    var card = document.getElementById('ao-nl-card');
    if (!card) return;
    card.innerHTML = '<button onclick="aoNlClose()" aria-label="Close" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#6b5a47;font-size:24px;cursor:pointer;line-height:1;padding:6px 10px;border-radius:6px;font-family:inherit">×</button>'+
      '<div style="text-align:center;padding:6px 0 0">'+
        '<div style="width:60px;height:60px;margin:0 auto 18px;border-radius:50%;background:#f7f1e8;display:flex;align-items:center;justify-content:center;border:1px solid rgba(184,146,74,.35)">'+
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#b8924a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>'+
        '</div>'+
        '<p style="text-transform:uppercase;letter-spacing:.28em;font-size:10px;color:#b8924a;margin:0 0 10px;font-weight:600">You\'re in</p>'+
        '<h3 style="font-family:\'Playfair Display\',Georgia,serif;font-size:26px;font-weight:500;color:#2b2521;margin:0 0 12px;line-height:1.25">Welcome to Adele Or</h3>'+
        '<p style="font-size:13px;color:#6b5a47;line-height:1.6;margin:0 0 8px">Here\'s your 15% off code for your first order:</p>'+
        '<p style="font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:#b8924a;margin:0 0 16px;font-weight:600">+ FREE SHIPPING ON ALL ORDERS</p>'+
        '<div style="display:flex;align-items:center;justify-content:center;gap:8px;background:#faf5ec;border:1px dashed rgba(184,146,74,.6);border-radius:10px;padding:14px 18px;margin:0 0 18px">'+
          '<input id="ao-nl-code" value="WELCOME15" readonly style="font-family:\'Helvetica Neue\',Arial,sans-serif;font-size:18px;font-weight:600;letter-spacing:.18em;color:#2b2521;border:none;background:transparent;text-align:center;width:130px;outline:none">'+
          '<button id="ao-nl-copy-btn" onclick="aoNlCopyCode()" style="background:#2b2521;color:#faf5ec;border:none;padding:9px 14px;border-radius:6px;font-size:10px;letter-spacing:.15em;text-transform:uppercase;font-weight:600;cursor:pointer;font-family:\'Helvetica Neue\',Arial,sans-serif">Copy</button>'+
        '</div>'+
        '<p style="font-size:11px;color:#a08e7a;margin:0 0 22px;line-height:1.55">Valid on your first order. Single use per customer.</p>'+
        '<a href="/collections/all" onclick="aoNlClose()" style="display:inline-block;background:#2b2521;color:#faf5ec;text-decoration:none;padding:13px 28px;border-radius:999px;font-size:11px;letter-spacing:.18em;text-transform:uppercase;font-weight:600">Start Shopping →</a>'+
      '</div>';
  }

  function aoNlShow(){
    if (!aoNlCanShow()) return;
    if (document.getElementById(NL_OVERLAY_ID)) return;
    var qz = document.getElementById(QUIZ_POPUP_ID); if (qz && qz.parentNode) qz.parentNode.removeChild(qz);
    var overlay = document.createElement('div');
    overlay.id = NL_OVERLAY_ID;
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(43,37,33,.55);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .35s ease;font-family:"Helvetica Neue",Arial,sans-serif;box-sizing:border-box';
    overlay.addEventListener('click', function(e){ if (e.target === overlay) aoNlClose(); });
    var card = document.createElement('div');
    card.id = 'ao-nl-card';
    card.style.cssText = 'position:relative;background:linear-gradient(135deg,#faf5ec 0%,#f7f1e8 100%);border:1px solid rgba(184,146,74,.4);border-radius:20px;box-shadow:0 24px 64px rgba(43,37,33,.3);padding:38px 36px 32px;max-width:440px;width:100%;box-sizing:border-box;transform:translateY(20px) scale(.98);transition:transform .35s cubic-bezier(.2,.9,.3,1)';
    card.innerHTML = '<button onclick="aoNlClose()" aria-label="Close" style="position:absolute;top:14px;right:16px;background:none;border:none;color:#6b5a47;font-size:24px;cursor:pointer;line-height:1;padding:6px 10px;border-radius:6px;font-family:inherit">×</button>'+
      '<div style="text-align:center">'+
        '<p style="text-transform:uppercase;letter-spacing:.28em;font-size:10px;color:#b8924a;margin:0 0 14px;font-weight:600">⚜ Exclusive Offer ⚜</p>'+
        '<h3 style="font-family:\'Playfair Display\',Georgia,serif;font-size:28px;font-weight:500;color:#2b2521;margin:0 0 10px;line-height:1.2">Save 15% on your<br>first order</h3>'+
        '<p style="font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#b8924a;margin:0 0 14px;font-weight:600">+ FREE SHIPPING ON ALL ORDERS</p>'+
        '<p style="font-size:13px;color:#6b5a47;line-height:1.6;margin:0 0 22px;max-width:320px;margin-left:auto;margin-right:auto">Join the Adele Or family and unlock fragrance crafted with botanical innovation.</p>'+
        '<form id="ao-nl-form" onsubmit="return aoNlSubmit(event)" style="display:flex;flex-direction:column;gap:10px;margin:0 0 12px">'+
          '<input type="email" required placeholder="Your email address" autocomplete="email" style="width:100%;padding:14px 16px;border:1px solid rgba(107,90,71,.25);background:#fff;border-radius:10px;font-size:14px;color:#2b2521;outline:none;font-family:inherit;box-sizing:border-box">'+
          '<button type="submit" style="background:#2b2521;color:#faf5ec;border:none;padding:14px 22px;border-radius:10px;font-size:11px;letter-spacing:.18em;text-transform:uppercase;font-weight:600;cursor:pointer;font-family:inherit;transition:background .2s">Get My 15% Off →</button>'+
        '</form>'+
        '<p style="font-size:10px;color:#a08e7a;margin:14px 0 0;letter-spacing:.04em;line-height:1.55">By signing up you agree to receive marketing emails.<br>Unsubscribe anytime.</p>'+
      '</div>';
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ overlay.style.opacity = '1'; card.style.transform = 'translateY(0) scale(1)'; });
  }

  /* ============================================================
   *  FREE SHIPPING PROGRESS BAR
   * ============================================================ */
  var SHIPPING_THRESHOLD = 65;
  var FS_BAR_ID = 'ao-shipping-bar';

  function aoFetchCart(cb){
    try { fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(j){ cb && cb(j); })
      .catch(function(){ cb && cb(null); });
    } catch(e) { cb && cb(null); }
  }
  function aoRenderShippingBar(cart){
    var bar = document.getElementById(FS_BAR_ID);
    if (!cart || cart.item_count === 0) { if (bar) bar.remove(); return; }
    var total = (cart.total_price || 0) / 100;
    var diff = Math.max(0, SHIPPING_THRESHOLD - total);
    var pct = Math.min(100, (total / SHIPPING_THRESHOLD) * 100);
    var qualified = diff === 0;
    var msg = qualified ? '🎉 You qualify for <strong>FREE SHIPPING</strong>' : 'Add <strong>$' + diff.toFixed(2) + '</strong> more for <strong>FREE SHIPPING</strong>';
    if (!bar) { bar = document.createElement('div'); bar.id = FS_BAR_ID; document.body.appendChild(bar); }
    bar.innerHTML = '<div class="ao-fs-bar__inner"><div class="ao-fs-bar__msg">' + msg + '</div><div class="ao-fs-bar__track"><div class="ao-fs-bar__fill" style="width:'+pct+'%"></div></div></div>';
    bar.className = qualified ? 'ao-fs-bar ao-fs-bar--qualified' : 'ao-fs-bar';
  }
  function aoUpdateShippingBar(){ aoFetchCart(aoRenderShippingBar); }

  function aoHookCartEvents(){
    var origFetch = window.fetch;
    if (origFetch && !window.aoFetchHooked) {
      window.aoFetchHooked = true;
      window.fetch = function(url, opts){
        var p = origFetch.apply(this, arguments);
        try {
          var u = typeof url === 'string' ? url : (url && url.url) || '';
          if (u.indexOf('/cart/') === 0 || u.indexOf('/cart.js') !== -1 || u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1) {
            p.then(function(){ setTimeout(aoUpdateShippingBar, 200); }).catch(function(){});
          }
        } catch(e){}
        return p;
      };
    }
    document.addEventListener('click', function(e){
      var el = e.target;
      if (!el) return;
      try {
        if (el.closest && (el.closest('[id^="cart-icon-bubble"]') || el.closest('a.cart') || el.closest('[data-cart-toggle]'))) {
          setTimeout(aoUpdateShippingBar, 300);
        }
      } catch(err){}
    }, true);
  }

  /* ============================================================
   *  TOOLTIPS
   * ============================================================ */
  function aoCleanLabel(text){
    if (!text) return null;
    var t = String(text).trim().replace(/^(go to |open |toggle |view |show |hide )/i, '');
    var words = t.split(/\s+/).slice(0, 3);
    return words.map(function(w){ return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' ');
  }
  function aoSmartLabel(text){
    var t = (text || '').toLowerCase();
    if (t.indexOf('search') !== -1) return 'Search';
    if (t.indexOf('cart') !== -1 || t.indexOf('basket') !== -1 || t.indexOf('bag') !== -1) return 'Cart';
    if (t.indexOf('account') !== -1 || t.indexOf('log in') !== -1 || t.indexOf('login') !== -1) return 'Account';
    if (t.indexOf('menu') !== -1 || t.indexOf('navigation') !== -1 || t.indexOf('burger') !== -1) return 'Menu';
    if (t.indexOf('wishlist') !== -1 || t.indexOf('favorite') !== -1) return 'Wishlist';
    if (t.indexOf('notification') !== -1 || t.indexOf('alert') !== -1 || t.indexOf('bell') !== -1) return 'Notifications';
    if (t.indexOf('language') !== -1 || t.indexOf('country') !== -1 || t.indexOf('region') !== -1) return 'Region';
    return aoCleanLabel(text);
  }
  function aoBestTooltipTarget(el){
    var s = el.closest && el.closest('summary'); if (s) return s;
    var a = el.closest && el.closest('a'); if (a) return a;
    var b = el.closest && el.closest('button'); if (b) return b;
    return el;
  }
  function aoAddTooltipTo(el, label){
    if (!el || !label) return;
    var t = aoBestTooltipTarget(el);
    t.classList.add('ao-has-tooltip');
    t.setAttribute('data-ao-tip', label);
  }
  function aoAddTooltips(){
    var containers = document.querySelectorAll('header, .header, .header-group, .site-header, .mobile-header, .header__content, [class*="header"], .navigation, .nav, #shopify-section-header, #shopify-section-mobile-header');
    var seen = new Set();
    containers.forEach(function(c){
      var els = c.querySelectorAll('a[aria-label], button[aria-label], summary[aria-label], [aria-label]:not(div):not(span)');
      els.forEach(function(el){
        if (seen.has(el)) return; seen.add(el);
        var aria = el.getAttribute('aria-label');
        if (!aria || aria.length > 50) return;
        var label = aoSmartLabel(aria);
        if (label) aoAddTooltipTo(el, label);
      });
    });
    var fallbacks = [
      { sel: '[id^="cart-icon-bubble"]', label: 'Cart' },
      { sel: 'button.burger-menu, burger-menu button', label: 'Menu' },
      { sel: 'a.search', label: 'Search' },
      { sel: 'a.cart', label: 'Cart' },
      { sel: 'a.account', label: 'Account' },
      { sel: '.search-container summary, .search-modal summary, search-modal summary', label: 'Search' }
    ];
    fallbacks.forEach(function(f){
      try { document.querySelectorAll(f.sel).forEach(function(el){ aoAddTooltipTo(el, f.label); }); } catch(e){}
    });
  }

  /* ============================================================
   *  TRUST BADGES on product page
   * ============================================================ */
  function aoAddTrustBadges(){
    if (window.location.pathname.indexOf('/products/') !== 0) return;
    if (document.getElementById('ao-trust-badges')) return;
    var atc = document.querySelector('.product-form__cart-submit, .product-form__buttons, [data-add-to-cart], button[name="add"]');
    if (!atc) return;
    var anchor = atc.closest('form') || atc.parentNode;
    if (!anchor) return;
    var badges = document.createElement('div');
    badges.id = 'ao-trust-badges';
    badges.innerHTML = '<div class="ao-trust"><div class="ao-trust__item"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><span>FREE SHIPPING ON ALL ORDERS</span></div><div class="ao-trust__item"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 1 18 0a9 9 0 1 1 -18 0"/><polyline points="12 7 12 12 15 14"/></svg><span>30-day returns</span></div><div class="ao-trust__item"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L4 7v5c0 5 3.5 9 8 10c4.5-1 8-5 8-10V7L12 2z"/><polyline points="9 12 11 14 15 10"/></svg><span>Botanical-Rich</span></div><div class="ao-trust__item"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg><span>Artisan Crafted</span></div></div>';
    anchor.parentNode.insertBefore(badges, anchor.nextSibling);
  }

  /* ============================================================
   *  STRUCTURED DATA (Schema.org) — Organization on every page
   *  Note: Product schema is generated by Shopify natively. This
   *  adds Organization + WebSite + SearchAction for better SERP.
   * ============================================================ */
  function aoAddOrgSchema(){
    if (document.getElementById('ao-org-schema')) return;
    var data = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://adeleor.com/#organization",
          "name": "Adele Or",
          "url": "https://adeleor.com",
          "logo": "https://cdn.shopify.com/s/files/1/0736/3385/7671/files/AdeleOr_Logo_Gold.png",
          "description": "Luxury botanical fragrance and skincare, hand-crafted in Florida. Where Fragrance Meets Botanical Innovation.",
          "email": "adeleor.beauty@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Lauderhill",
            "addressRegion": "FL",
            "postalCode": "33319",
            "addressCountry": "US"
          },
          "sameAs": []
        },
        {
          "@type": "WebSite",
          "@id": "https://adeleor.com/#website",
          "url": "https://adeleor.com",
          "name": "Adele Or",
          "publisher": { "@id": "https://adeleor.com/#organization" },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://adeleor.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }
      ]
    };
    var script = document.createElement('script');
    script.id = 'ao-org-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  }

  /* ============================================================
   *  INIT
   * ============================================================ */
  function aoInit(){
    aoAddOrgSchema();
    aoAddTooltips();
    setTimeout(aoAddTooltips, 800);
    setTimeout(aoAddTooltips, 2500);
    aoAddTrustBadges();
    setTimeout(aoAddTrustBadges, 800);
    setTimeout(aoAddTrustBadges, 2500);
    aoHookCartEvents();
    aoUpdateShippingBar();
    aoApplyGenderTags();
    setTimeout(aoApplyGenderTags, 600);
    setTimeout(aoApplyGenderTags, 1800);
    aoApplyCardSubtitles();
    setTimeout(aoApplyCardSubtitles, 600);
    setTimeout(aoApplyCardSubtitles, 1800);
    aoHideVariantSizeText();
    setTimeout(aoHideVariantSizeText, 600);
    setTimeout(aoHideVariantSizeText, 1800);
    setTimeout(aoHideVariantSizeText, 3500);
    aoAddSizeDropdowns();
    setTimeout(aoAddSizeDropdowns, 1000);
    setTimeout(aoAddSizeDropdowns, 2500);
    setTimeout(aoQuizShow, QUIZ_DELAY);
    setTimeout(aoNlShow, NL_DELAY);
  }

  /* ============================================================
   *  INSPIRED BY SUBTITLE on collection product cards
   *  Reads scent name from card title and adds matching subtitle
   * ============================================================ */
  var AO_SCENT_SUBTITLES = {
    'ODEM': 'Inspired by Baccarat Rouge',
    'EMUNA': 'Inspired by Angel Muse',
    'VELVET MALLOW': 'Signature Scent',
    'DREAM MUSC': 'Signature Scent',
    'OR DE ROSÉE': 'Inspired by Delina Exclusif',
    'OR DE ROSEE': 'Inspired by Delina Exclusif',
    'OPAL': 'Inspired by Libre'
  };
  function aoApplyCardSubtitles(){
    try {
      // Cast wide net for any product card container
      var cards = document.querySelectorAll(
        'product-card, .product-card, .card-wrapper, .grid__item, ' +
        '.card, .collection-card, .product-grid-item, [class*="product-card"], ' +
        '[class*="card-wrapper"], li[class*="grid__item"]'
      );
      cards.forEach(function(card){
        if (card.querySelector('.ao-card-subtitle')) return;
        // Search for title element - very wide net
        var candidates = card.querySelectorAll(
          'h1, h2, h3, h4, ' +
          '.card__heading, .card__title, .product-card__title, ' +
          '.card-information__heading, .card-information h3, .card-information a, ' +
          '[class*="heading"], [class*="title"], ' +
          '.full-unstyled-link, .card-information__wrapper a'
        );
        var foundEl = null;
        var foundScent = null;
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          // Only check leaf-ish elements (not containers wrapping many things)
          if (el.querySelector('img, picture, .price, .card-information')) continue;
          var text = (el.textContent || '').trim().toUpperCase();
          // Remove non-letter chars for matching (handle weird whitespace)
          var clean = text.replace(/[^A-ZÉÈÊËÀÂÄÔÖÙÛÜÇ ]/g, '').trim();
          if (AO_SCENT_SUBTITLES[clean] || AO_SCENT_SUBTITLES[text]) {
            foundScent = AO_SCENT_SUBTITLES[clean] || AO_SCENT_SUBTITLES[text];
            foundEl = el;
            break;
          }
        }
        if (!foundEl || !foundScent) return;
        var div = document.createElement('div');
        div.className = 'ao-card-subtitle';
        div.textContent = foundScent;
        // Find the right insertion point: walk up to the heading-level element
        // so we don't insert INSIDE the title (which makes it inline).
        var insertAfter = foundEl;
        // Climb up to the actual heading/title block element (h1-h4, .card__heading, etc)
        while (insertAfter && insertAfter !== card) {
          var tag = (insertAfter.tagName || '').toLowerCase();
          var cls = insertAfter.className || '';
          if (
            tag === 'h1' || tag === 'h2' || tag === 'h3' || tag === 'h4' ||
            (typeof cls === 'string' && (cls.indexOf('card__heading') !== -1 || cls.indexOf('card-information__heading') !== -1))
          ) break;
          insertAfter = insertAfter.parentNode;
        }
        // If we hit the card itself, fall back to foundEl
        if (!insertAfter || insertAfter === card) insertAfter = foundEl;
        // If the heading is wrapped in an anchor, insert AFTER the anchor instead
        var anchor = insertAfter.closest('a');
        if (anchor && card.contains(anchor) && anchor !== card) {
          insertAfter = anchor;
        }
        if (insertAfter.parentNode) {
          insertAfter.parentNode.insertBefore(div, insertAfter.nextSibling);
        }
      });
    } catch(e){ /* swallow */ }
  }
  // Re-apply when collection filters/sort load new cards
  document.addEventListener('shopify:section:load', function(){
    setTimeout(aoApplyCardSubtitles, 200);
    setTimeout(aoHideVariantSizeText, 200);
    setTimeout(aoAddSizeDropdowns, 400);
  });
  window.addEventListener('popstate', function(){
    setTimeout(aoApplyCardSubtitles, 400);
    setTimeout(aoHideVariantSizeText, 400);
    setTimeout(aoAddSizeDropdowns, 600);
  });

  /* ============================================================
   *  HIDE "100ml / 3.4 fl oz  15ml / 0.5 fl oz" text in cards
   *  Aggressively scans card elements for size-pattern text and hides it.
   * ============================================================ */
  /* ============================================================
   *  SIZE DROPDOWN on collection cards — Valentino-style
   *  Fetches /products/[handle].js for each card and adds a Size dropdown.
   *  Only adds if product has a "Size" option with 2+ values.
   * ============================================================ */
  function aoAddSizeDropdowns(){
    try {
      var cards = document.querySelectorAll(
        '.card, .product-card, .card-wrapper, product-card, .grid__item'
      );
      cards.forEach(function(card){
        if (card.querySelector('.ao-size-dropdown')) return;
        if (card.dataset.aoSizeProcessing === '1') return;
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (!match) return;
        var handle = match[1];
        card.dataset.aoSizeProcessing = '1';
        fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r){ if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function(product){
            if (!product || !product.options || !product.variants) return;
            // Find Size option
            var sizeIdx = -1;
            (product.options || []).forEach(function(opt, i){
              var name = (typeof opt === 'string' ? opt : opt.name) || '';
              if (name.toLowerCase().indexOf('size') !== -1) sizeIdx = i;
            });
            if (sizeIdx === -1) return;
            // Collect unique size values (in display order)
            var seen = {};
            var sizes = [];
            product.variants.forEach(function(v){
              var key = v.options && v.options[sizeIdx];
              if (key && !seen[key]) {
                seen[key] = true;
                sizes.push({label: key, variantId: v.id});
              }
            });
            if (sizes.length < 2) return;
            // Build CUSTOM dropdown (button + menu) — not <select>, for full event control
            var wrap = document.createElement('div');
            wrap.className = 'ao-size-dropdown';
            var label = document.createElement('span');
            label.className = 'ao-size-dropdown__label';
            label.textContent = 'Size';
            wrap.appendChild(label);
            var btn = document.createElement('div');
            btn.setAttribute('role', 'button');
            btn.setAttribute('tabindex', '0');
            btn.className = 'ao-size-dropdown__button';
            btn.textContent = (sizes[0].label || '').toUpperCase();
            wrap.appendChild(btn);
            var menu = document.createElement('ul');
            menu.className = 'ao-size-dropdown__menu';
            var productUrl = link.getAttribute('href').split('?')[0];
            sizes.forEach(function(s, i){
              var li = document.createElement('li');
              li.className = 'ao-size-dropdown__option' + (i === 0 ? ' selected' : '');
              li.textContent = (s.label || '').toUpperCase();
              li.setAttribute('data-variant-id', s.variantId);
              li.setAttribute('data-product-url', productUrl);
              li.addEventListener('click', function(e){
                e.stopPropagation();
                e.preventDefault();
                window.location.href = productUrl + '?variant=' + s.variantId;
              }, true);
              li.addEventListener('touchstart', function(e){ e.stopPropagation(); }, true);
              menu.appendChild(li);
            });
            wrap.appendChild(menu);
            // Toggle open on button click
            btn.addEventListener('click', function(e){
              e.stopPropagation();
              e.preventDefault();
              // Close all other open dropdowns
              document.querySelectorAll('.ao-size-dropdown.open').forEach(function(d){
                if (d !== wrap) d.classList.remove('open');
              });
              wrap.classList.toggle('open');
            }, true);
            // Stop propagation on ALL touch/mouse events from wrap (don't preventDefault)
            var stopOnly = function(e){
              e.stopPropagation();
              if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            };
            ['click','mousedown','mouseup','touchstart','touchend','pointerdown','pointerup'].forEach(function(ev){
              wrap.addEventListener(ev, stopOnly, true);
            });
            // Insert OUTSIDE any wrapping <a> tag (lift out of link)
            var price = card.querySelector('.price, .card__price, .product-card__price, [class*="price-item"]');
            var info = card.querySelector('.card__information, .card-information');
            var target = info || card;
            var anchor = (price || target).closest('a');
            if (anchor && card.contains(anchor)) {
              if (anchor === card) {
                // The card itself is a link — append to card's parent so wrap is not inside <a>
                if (card.parentNode) {
                  // Wrap card in a relative container if needed, then put dropdown floating inside it
                  card.style.position = card.style.position || 'relative';
                  card.appendChild(wrap);
                } else {
                  anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
                }
              } else {
                anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
              }
            } else if (price) {
              var priceContainer = price.closest('.card__information, .card-information, .product-card__info') || price.parentNode;
              priceContainer.insertBefore(wrap, price);
            } else if (info) {
              info.appendChild(wrap);
            }
          })
          .catch(function(){})
          .finally(function(){ delete card.dataset.aoSizeProcessing; });
      });
    } catch(e){ /* swallow */ }
  }

  // GLOBAL CAPTURE handler — intercepts all dropdown clicks BEFORE the card link
  if (!window.__aoDropdownHandlerInstalled) {
    window.__aoDropdownHandlerInstalled = true;
    var handleDropdownEvent = function(e){
      var target = e.target;
      if (!target || !target.closest) return;
      // Click on a dropdown OPTION → navigate
      var option = target.closest('.ao-size-dropdown__option');
      if (option) {
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.preventDefault();
        if (e.type === 'click') {
          var url = option.getAttribute('data-product-url');
          var vid = option.getAttribute('data-variant-id');
          if (url && vid) {
            window.location.href = url + '?variant=' + vid;
          }
        }
        return false;
      }
      // Click on the dropdown BUTTON → toggle open
      var btn = target.closest('.ao-size-dropdown__button');
      if (btn) {
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.preventDefault();
        if (e.type === 'click') {
          var wrap = btn.closest('.ao-size-dropdown');
          if (wrap) {
            document.querySelectorAll('.ao-size-dropdown.open').forEach(function(d){
              if (d !== wrap) d.classList.remove('open');
            });
            wrap.classList.toggle('open');
          }
        }
        return false;
      }
      // Click anywhere else inside a dropdown wrap → just stop propagation
      var wrap2 = target.closest('.ao-size-dropdown');
      if (wrap2) {
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (e.type === 'click') e.preventDefault();
        return false;
      }
      // Click outside any dropdown → close all open
      if (e.type === 'click') {
        document.querySelectorAll('.ao-size-dropdown.open').forEach(function(d){
          d.classList.remove('open');
        });
      }
    };
    // Capture phase on document — runs BEFORE the card link receives event
    ['click','mousedown','touchstart','pointerdown'].forEach(function(ev){
      document.addEventListener(ev, handleDropdownEvent, true);
    });
  }

  function aoHideVariantSizeText(){
    try {
      var cards = document.querySelectorAll(
        '.card, .product-card, .card-wrapper, product-card, .grid__item, [class*="product-card"]'
      );
      cards.forEach(function(card){
        // Walk all leaf-text nodes in the card
        var walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT, null, false);
        var node;
        var sizePattern = /\d+\s*ml\s*(\/|·|•)\s*[\d.]+\s*fl\s*oz/i;
        var nodesToHide = [];
        while (node = walker.nextNode()) {
          var text = (node.nodeValue || '').trim();
          if (sizePattern.test(text)) {
            // Find the closest container to hide (but not the whole card)
            var el = node.parentNode;
            while (el && el !== card) {
              // Don't hide structural containers
              if (el.classList && (
                el.classList.contains('card') ||
                el.classList.contains('card-wrapper') ||
                el.classList.contains('card__information') ||
                el.classList.contains('card-information')
              )) break;
              // Hide if it's a leaf-ish element
              if (el.children.length <= 2 || el.textContent.length < 80) {
                nodesToHide.push(el);
                break;
              }
              el = el.parentNode;
            }
          }
        }
        nodesToHide.forEach(function(el){
          el.style.display = 'none';
          el.classList.add('ao-variant-hide');
        });
      });
    } catch(e){ /* swallow */ }
  }


  /* ============================================================
   *  GENDER TAG on collection cards + product page
   *  Source: product.metafields.adeleor.gender  (e.g. "Women", "Men", "Women+Men", "Unisex")
   *  Falls back to product tags (women / men / unisex)
   * ============================================================ */
  function aoNormalizeGender(raw){
    if (!raw) return null;
    var v = String(raw).trim().toLowerCase();
    if (v.indexOf('women') !== -1 && v.indexOf('men') !== -1) return 'WOMEN / MEN';
    if (v === 'unisex') return 'UNISEX';
    if (v.indexOf('women') !== -1 || v === 'w' || v === 'female') return 'WOMEN';
    if (v.indexOf('men') !== -1 || v === 'm' || v === 'male') return 'MEN';
    return null;
  }
  function aoExtractGenderFromCard(card){
    var explicit = card.getAttribute('data-ao-gender');
    if (explicit) return aoNormalizeGender(explicit);
    var hidden = card.querySelector('[data-product-tags]');
    if (hidden) {
      var tags = hidden.getAttribute('data-product-tags') || '';
      var t = tags.toLowerCase();
      var hasW = t.indexOf('women') !== -1 || t.indexOf('for-women') !== -1;
      var hasM = t.indexOf('men') !== -1 && t.indexOf('women') === -1 || t.indexOf('for-men') !== -1;
      if (hasW && (t.indexOf('men') !== -1 && t.indexOf('women') === -1)) return 'WOMEN / MEN';
      if (hasW) return 'WOMEN';
      if (hasM) return 'MEN';
      if (t.indexOf('unisex') !== -1) return 'UNISEX';
    }
    return null;
  }
  function aoApplyGenderTags(){
    try {
      // Collection cards
      var cards = document.querySelectorAll('product-card, .product-card, .grid__item .card, .collection .card-wrapper');
      cards.forEach(function(card){
        if (card.querySelector('.ao-gender-tag')) return;
        var g = aoExtractGenderFromCard(card);
        if (!g) return;
        var title = card.querySelector('.card__heading, .card-information__heading, .card__title, h3, h4');
        if (!title) return;
        var tag = document.createElement('span');
        tag.className = 'ao-gender-tag';
        tag.textContent = g;
        title.parentNode.insertBefore(tag, title.nextSibling);
      });
      // Product page (single)
      var prodTitle = document.querySelector('.product__title, .product-single__title, h1.product__title, .product-info h1');
      if (prodTitle && !prodTitle.parentNode.querySelector('.ao-gender-tag--product')) {
        var meta = document.querySelector('meta[name="ao-product-gender"]');
        if (meta) {
          var g2 = aoNormalizeGender(meta.getAttribute('content'));
          if (g2) {
            var tag2 = document.createElement('div');
            tag2.className = 'ao-gender-tag ao-gender-tag--product';
            tag2.textContent = g2;
            prodTitle.parentNode.insertBefore(tag2, prodTitle.nextSibling);
          }
        }
      }
    } catch(e){ /* swallow */ }
  }
  // Re-apply when collection filters/sort load new cards (event delegation)
  document.addEventListener('shopify:section:load', function(){ setTimeout(aoApplyGenderTags, 200); });
  window.addEventListener('popstate', function(){ setTimeout(aoApplyGenderTags, 400); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aoInit);
  } else {
    aoInit();
  }
})();